import { Card } from '../../../components/Card/Card';
import { useContext, useState } from 'react';
import { PatientRecord } from '../../../shared/types/types';
import './CheckIn.scss';
import { Button } from 'src/components/Button/Button';
import { ExclamationOutlined } from 'src/icons/ExclamationOutlined';
import { ExternalUserVerifyContext } from 'src/shared/contexts/ExternalAprrovalContext';
import { v4 as uuidv4 } from 'uuid';
import { useNavigate } from 'react-router-dom';
import { BannerMessageContext } from 'src/shared/contexts/BannerMessageContext';
import { LoadingSpinner, mediumSpinner } from 'src/components/common/loader/LoadingSpinner';
import { fetchAuthenticated } from 'src/controllers';
import { PopupMessageContext } from 'src/shared/contexts/PopupMessageContext';
import { TAS_BACK_END_API_URL } from 'src/constants';

export interface UpdatePatientInfoProps {
  patientData?: Partial<PatientRecord>;
}

export interface CheckInProps {
  patientData?: PatientRecord;
  token: string | null;
  patientInfoIsLoading: boolean;
}

export function CheckIn({ patientData, token, patientInfoIsLoading }: CheckInProps) {
  const [expanded, setIsExpanded] = useState(true);
  const { checkAuthorization } = useContext(ExternalUserVerifyContext);
  const { addBannerMessage } = useContext(BannerMessageContext);

  const [checkInId, setCheckInId] = useState('');
  const [checkingIn, setCheckingIn] = useState(false);

  const navigate = useNavigate();
  const { addPopupMessage } = useContext(PopupMessageContext);

  const handlePatientInfoExpand = () => {
    setIsExpanded(!expanded);
  };
  const handlePatientInfoChange = (value: string) => {
    setCheckInId(value);
  };

  const handleCheckInClick = async () => {
    if (patientData?.encrypt_medicalId !== checkInId) {
      addBannerMessage({
        id: uuidv4(),
        message: 'Please provide a valid Patient Code',
        type: 'warning',
      });
      return;
    } else if (patientData?.encrypt_medicalId === checkInId) {
      if (checkingIn) return;
      setCheckingIn(true);
      if (!checkAuthorization) return;
      let result;
      try {
        result = await checkAuthorization();
      } catch (error) {
        addBannerMessage({
          id: uuidv4(),
          type: 'error',
          message: 'Incorrect Access Credentials',
        });
      }
      if (result?.verified) {
        if (result?.verified) {
          const url = TAS_BACK_END_API_URL + `/batonTreatmentRequest/${patientData?._id}`;

          const result = await fetchAuthenticated(url, {
            method: 'POST',
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({}),
          });

          if (result?.ok) {
            addBannerMessage({
              id: uuidv4(),
              message: 'Check In Successful.',
              type: 'success',
            });
            navigate(`/infusions/${patientData?._id}`);
          } else {
            addPopupMessage({
              id: uuidv4(),
              message: 'An error occurred when trying to check in this patient.',
              header: 'Unapproval',
            });
          }
        } else {
          addPopupMessage({
            id: uuidv4(),
            message: 'Sorry, you are not authorized to check in a patient.',
            header: 'Unapproval',
          });
        }

        setCheckingIn(false);
        navigate(`/infusions/${patientData?._id}`);
      }
    }
    setCheckingIn(false);
  };
  const body = (
    <div className="patient-checkin-container">
      {!patientInfoIsLoading ? (
        <div className="input-container">
          <div className="label-info-container">
            <div className="label">Please Type or Scan Patient Code</div>
            <input
              className="textfield"
              placeholder={'                 XXXXX-XXXXX-XXXXX'}
              onChange={(e) => {
                handlePatientInfoChange(e.target.value);
              }}
              value={checkInId}
              disabled={checkingIn}
            ></input>
          </div>
        </div>
      ) : (
        <div className="loading-container">
          <LoadingSpinner width={mediumSpinner} height={mediumSpinner} />
        </div>
      )}
      <div className={'checkin-container'}>
        {!checkingIn ? (
          <Button
            label={'Check In'}
            onClick={() => handleCheckInClick()}
            className="edit-button"
            icon={<ExclamationOutlined />}
            iconPlacement="right"
            disabled={patientInfoIsLoading}
          />
        ) : (
          <LoadingSpinner width={mediumSpinner} height={mediumSpinner} />
        )}
      </div>
    </div>
  );

  return (
    <div className="patient-info-container">
      <Card title={'PATIENT Check-In'} body={expanded ? body : <></>} onExpand={handlePatientInfoExpand} expandable={true} expanded={expanded} />
    </div>
  );
}
